type Props = {
  label?: string;
};

/** In-page loading - spinner + subdued label inside a section (BFS / App Home). */
export function PageLoading({ label = "Loading…" }: Props) {
  return (
    <s-section>
      <s-stack direction="inline" gap="base" alignItems="center">
        <s-spinner accessibilityLabel={label} />
        <s-paragraph color="subdued">{label}</s-paragraph>
      </s-stack>
    </s-section>
  );
}
